const BUTTONS_OFFSET_X = 105;
const FIRST_BUTTON_POSITION_Y = 85;
const SPACE_BETWEEN_BUTTONS = 16;

const RADIUS_SMALL = 31;
const RADIUS_MEDIUM = 43;

const DIAMETER_SMALL = RADIUS_SMALL * 2;
const DIAMETER_MEDIUM = RADIUS_MEDIUM * 2;

const STEP_SMALL = DIAMETER_SMALL + SPACE_BETWEEN_BUTTONS; // 78
const STEP_MEDIUM = DIAMETER_MEDIUM + SPACE_BETWEEN_BUTTONS; // 102

const BUTTON_CLAIM_POSITION_Y = FIRST_BUTTON_POSITION_Y + STEP_MEDIUM;

export {
  BUTTONS_OFFSET_X,
  FIRST_BUTTON_POSITION_Y,
  SPACE_BETWEEN_BUTTONS,
  RADIUS_SMALL,
  RADIUS_MEDIUM,
  DIAMETER_SMALL,
  DIAMETER_MEDIUM,
  STEP_SMALL,
  STEP_MEDIUM,
  BUTTON_CLAIM_POSITION_Y
};
